// Miami University's undergraduate majors (#2743). Read on 2026-10-01 from
// the official General Bulletin 2026-2027 (bulletin.miamioh.edu): every
// bachelor's program page linked from each college's bulletin page, with the
// degree in the page's own title ("Anthropology- Bachelor of Arts"). Left
// out: minors, certificates, associate degrees, and co-majors (Miami's
// co-majors, such as Neuroscience or Entrepreneurship, are taken alongside a
// primary major, not on their own). Two bulletin links (an Art Education B.S.
// and a Music Performance B.M. page) returned "404 Not Found" and are left
// out. Degrees are written as the bulletin writes them, with the repeated
// major name dropped ("Bachelor of Arts in International Studies" ->
// "Bachelor of Arts"). The official major name "Artificial Intelligence" is
// kept as written. The KB's majors list was the starting point; the bulletin
// wins.
const majors = {
    "slug": "miami-university-oxford-ohio",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Miami's official 2026-2027 General Bulletin, grouped by the college that offers it, with the degree it leads to. Minors, certificates, associate degrees, co-majors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Science",
            "source": {
                "label": "Miami General Bulletin 2026-2027, College of Arts and Science",
                "url": "https://bulletin.miamioh.edu/arts-science/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Botany",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Botany",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Data Analytics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Data, Actuarial, and Statistical Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Diplomacy and Global Politics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English: Creative Writing",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English: Literature",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Earth Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geography and Sustainable Development",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Individualized Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Individualized Studies",
                    "degree": "Bachelor of Philosophy"
                },
                {
                    "name": "International Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Linguistics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mathematics and Statistics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Media and Communication",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Professional Writing",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Administration",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Health",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Quantitative Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Spanish",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Speech Pathology and Audiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Strategic Communication",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Urban and Regional Planning",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Zoology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Zoology",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Creative Arts",
            "source": {
                "label": "Miami General Bulletin 2026-2027, College of Creative Arts",
                "url": "https://bulletin.miamioh.edu/creative-arts/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Arts Management and Arts Entrepreneurship",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Games + Simulation",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Graphic + Experience Design",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Interactive Media and Design",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interior Design",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Performing Arts",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "College of Education, Health and Society",
            "source": {
                "label": "Miami General Bulletin 2026-2027, College of Education, Health and Society",
                "url": "https://bulletin.miamioh.edu/education-health-society/"
            },
            "majors": [
                {
                    "name": "Inclusive Education",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Integrated English Language Arts Education",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Integrated Mathematics Education",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Integrated Science Education",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Integrated Social Studies Education",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Kinesiology",
                    "degree": "Bachelor of Science in Kinesiology, Nutrition, and Health"
                },
                {
                    "name": "Middle Childhood Education",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Nutrition",
                    "degree": "Bachelor of Science in Kinesiology, Nutrition, and Health"
                },
                {
                    "name": "Primary Education PK-5",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sport Coaching",
                    "degree": "Bachelor of Science in Sport Leadership and Management"
                },
                {
                    "name": "Sport Communication and Media",
                    "degree": "Bachelor of Science in Sport Leadership and Management"
                },
                {
                    "name": "Sport Management",
                    "degree": "Bachelor of Science in Sport Leadership and Management"
                }
            ]
        },
        {
            "name": "College of Engineering and Computing",
            "source": {
                "label": "Miami General Bulletin 2026-2027, College of Engineering and Computing",
                "url": "https://bulletin.miamioh.edu/engineering-computing/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Engineering Management",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Quantum Computing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Robotics Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Smart Manufacturing Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Software Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Farmer School of Business",
            "source": {
                "label": "Miami General Bulletin 2026-2027, Farmer School of Business",
                "url": "https://bulletin.miamioh.edu/farmer-business/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Business Analytics",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Business-Economics",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Human Capital Management and Leadership",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Information Systems and Cybersecurity Management",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Real Estate",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Supply Chain and Operations Management",
                    "degree": "Bachelor of Science in Business"
                }
            ]
        },
        {
            "name": "College of Liberal Arts and Applied Science",
            "source": {
                "label": "Miami General Bulletin 2026-2027, College of Liberal Arts and Applied Science",
                "url": "https://bulletin.miamioh.edu/liberal-arts-applied-science/"
            },
            "majors": [
                {
                    "name": "Applied Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of Arts in Applied Communication"
                },
                {
                    "name": "Community Arts and Cultures",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity & Networking",
                    "degree": "Bachelor of Science in Information Technology"
                },
                {
                    "name": "Digital Commerce",
                    "degree": "Bachelor of Science in Commerce"
                },
                {
                    "name": "Engineering Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "English Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Information Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Integrative Studies",
                    "degree": "Bachelor of Integrative Studies"
                },
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Professional Studies",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Psychological Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sales Management",
                    "degree": "Bachelor of Science in Commerce"
                },
                {
                    "name": "Small Business Management",
                    "degree": "Bachelor of Science in Commerce"
                }
            ],
            "note": "This college's bulletin pages describe Miami's regional campuses (Hamilton, Middletown and West Chester); check where a program is offered."
        }
    ]
};

export default majors;
